import axios from "axios";

export const TITULO_URL = `Titulo`;

export const tituloServices = {
  lookup: () => {
    return axios.get<any>(`${TITULO_URL}/Lookup`);
  },
};
